import React from 'react'
import Card from 'components/Card'
import './source.css'

export default function Sources({ sources, aID }) {
    return (
        <React.Fragment>
            {
                sources.map((source) => (
                    <Card inline key={source.alias} title={ source.alias }>
                        <div className='source__status'></div>
                        <div className='source__baseUrl'>Base URL<br/>https://cdn.tueri.io/{ aID }/{ source.alias }/</div>
                        <div>{source.directory}</div>
                    </Card>
                ))
            }
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Sources/index.js